import { Observable } from 'rxjs';
import { AutovistoriaAPI } from '@/api/autovistoria.api';

const api = new AutovistoriaAPI();

const listStatus = (): Observable<any> => {
  return api.listStatus();
}

export default {
  listStatus
}
